<template>
    <Card :bordered="false" class="border-radius-0">
        <CCard
            :isLoading="isLoading"
            v-model:columns="state.columns"
            v-model:page="state.page"
            :options="state.tableOptions"
            :manages="state.manages"
            :manageExtras="state.manageExtras"
            :rowActions="state.rowActions"
            :clientSide="true"
            :canRefresh="false"
            :visiblePagination="false"
            :visibleSearch="false"
            @search="search => onSearch({ props, ...search })"
        >
            <template v-slot:item="{ record }">
                <div class="p-2">
                    <router-link :to="`/app/report/reports/${record.key}`" class="my-auto">
                        <span>{{ record.value }}</span>
                    </router-link>
                </div>
            </template>
        </CCard>
    </Card>
</template>

<script>
import { Card } from "ant-design-vue";
import { defineAsyncComponent, defineComponent } from "vue";
import { state as stateApp } from "../../../../app.logic";
import { isLoading, onSearch, state } from "./report.logic";

export default defineComponent({
    components: {
        Card,
        CCard: defineAsyncComponent(() => import("../../../../components/card/CCard"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext }
    },
    setup(props) {
        onSearch({ props, page: state.page });
        return { props, state, isLoading, onSearch };
    }
});
</script>
